import { NBSP_JS } from 'constants/unicode/nbsp-js';

export const ASSETS_ITEMS_PER_PAGE = 10;
export const TYPE_AND_NAME = 'type and name';
export const HASH_RATE_AND_QUANTITY = `Hash rate &${NBSP_JS}quantity`;
export const POWER_CONSUMPTION = 'Power consumption';
export const DAILY_INCOME = 'daily income';
export const STATUS = 'status';
export const ASSETS = 'My assets';
